import React from 'react';
import loadable from '@loadable/component';
import { tw } from '@careinfo/tailwind';
import CreateIcon from '../Icons/CreateIcon';
import usePostHook from '../customHooks/usePostHook';
import APIS from '../constant/EndPoint';
import { useNavigate } from 'react-router-dom';
const CreateCombineOrderComponent = loadable(
  () => import('../components/CombineOrder/CreateCombineOrder')
);
const CreateCombineOrder = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['manifest'],
  });
  const navigate = useNavigate();
  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.COMBINE_ORDERS}`;
    let formData = {
      ...values,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 201) {
        navigate(`/edit/${res?.data?.id}`);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Combined Order
        </span>
      </div>
      <CreateCombineOrderComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default CreateCombineOrder;
